import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import "./App.scss";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import PaymentStatus from "./pages/PaymentStatus";
import { EStatusTrip } from "./helpers/const";
import Tracking from "./pages/Tracking";
import $axios from "./services/axios";
import { message } from "antd";
import dayjs from "dayjs";

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const decodeToken = async () => {
    // Lấy token từ URL
    const queryParams = new URLSearchParams(window.location.search);
    if (
      queryParams.get("loginToken") ||
      localStorage.getItem("taxiIpassToken")
    ) {
      try {
        const verifyToken = queryParams.get("loginToken");
        if (verifyToken) {
          const res = await $axios.$post("/api/v1/login", {
            VerifyToken: verifyToken,
          });
          localStorage.setItem("taxiIpassToken", res.data.data.token);
          const userInfo = res.data.data.userInfo;
          userInfo.phone = userInfo.phone.replace(/^84/, "0");
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          queryParams.delete("loginToken");
          // history.replace({
          //   pathname: location.pathname,
          //   search: queryParams.toString(),
          // });
        }
      } catch (error) {
        message.error(error?.message || "Xảy ra lỗi vui lòng thử lại !");
      }
    }
  };

  useEffect(() => {
    if (location.pathname === "/taxi") {
      fetchBookingInfo();
    }
  }, [location]);

  const fetchBookingInfo = async () => {
    const end = dayjs();
    const start = end.subtract(6, "day");
    const startTime = start.format("DD/MM/YYYY") + " 00:00:00";
    const endTime = end.format("DD/MM/YYYY") + " 00:00:00";
    try {
      const res = await $axios.$get(
        `/api/v1/gsm/transactions/list?startDate=${startTime}&endDate=${endTime}&page=${1}&pageSize=10`
      );
      const histories = res.data.data.data;
      if (histories.length > 0) {
        const tripId = histories[0].tripId;
        const resTrip = await $axios.get(`/api/v1/gsm/trip/tracking?tripId=${tripId}`);
        if (resTrip?.data?.data) {
          if (
            [
              EStatusTrip.ARRIVED,
              EStatusTrip.COMING,
              EStatusTrip.FINDING,
              EStatusTrip.JOURNEY,
            ].includes(resTrip?.data?.data.status)
          ) {
            message.success("Bạn có chuyến đi chưa hoàn thành!");
            history.push(`/tracking?orderCode=${histories[0].orderCode}`);
          }
        }
      }
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/taxi"} />
        <Route
          exact
          path={"/taxi"}
          render={(props) => <Home {...props} />}
        />
        <Route
          exact
          path={"/payment-status"}
          render={(props) => <PaymentStatus {...props} />}
        />
        <Route
          exact
          path={"/tracking"}
          render={(props) => <Tracking {...props} />}
        />
        <Redirect to={"/taxi"} />
      </Switch>
    </>
  );
};
export default App;
